import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContextTest'
import Sidebar from './Sidebar'
import Header from './Header'
import {
  LayoutDashboard,
  Users,
  Shield,
  Building2,
  UserCheck,
  Ruler,
  Settings,
  Package,
  Package2,
  UserCog,
  ShoppingCart,
  CreditCard,
  Receipt,
  Banknote,
  BookOpen,
  Building,
  FileText
} from 'lucide-react'

const navigation = [
  {
    name: 'Dashboard',
    href: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    name: 'Users',
    href: '/users',
    icon: Users,
  },
  {
    name: 'Roles',
    href: '/roles',
    icon: Shield,
  },
  {
    name: 'Companies',
    href: '/companies',
    icon: Building2,
  },
  {
    name: 'Customers',
    href: '/customers',
    icon: UserCheck,
  },
  // {
  //   name: 'Customer Measurements',
  //   href: '/customer-measurements',
  //   icon: Ruler,
  // },
  {
    name: 'Measurement Setup',
    href: '/measurement-setup',
    icon: Settings,
  },
  // {
  //   name: 'Stock',
  //   href: '/stock',
  //   icon: Package,
  // },
  // {
  //   name: 'Stock Transactions',
  //   href: '/stock-transactions',
  //   icon: Package2,
  // },
  // {
  //   name: 'Employees',
  //   href: '/employees',
  //   icon: UserCog,
  // },
  // {
  //   name: 'Orders',
  //   href: '/orders',
  //   icon: ShoppingCart,
  // },
  // {
  //   name: 'Payments',
  //   href: '/payments',
  //   icon: CreditCard,
  // },
  {
    name: 'Invoices',
    href: '/invoices',
    icon: FileText,
  },
  // {
  //   name: 'Products',
  //   href: '/products',
  //   icon: Package,
  // },
  // {
  //   name: 'Expenses',
  //   href: '/expenses',
  //   icon: Receipt,
  // },
  // {
  //   name: 'Accounts',
  //   href: '/accounts',
  //   icon: BookOpen,
  // },
  // {
  //   name: 'Bank Details',
  //   href: '/bank-details',
  //   icon: Building,
  // },
]

function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { user } = useAuth()
  const location = useLocation()

  console.log('Layout render - user:', user)
  console.log('Layout render - children:', children)
  console.log('Layout render - location:', location.pathname)

  // Filter navigation based on user role
  const getFilteredNavigation = () => {
    if (!user || !user.role) {
      return [navigation[0]] // Only show Dashboard for unauthenticated users
    }

    const userRoleId = user.role.id
    console.log('User role ID:', userRoleId)

    // Super Admin (role ID = 1) - access to all services
    if (userRoleId === 1) {
      return navigation
    }

    // Company Owner (role ID = 2) - limited access
    if (userRoleId === 2) {
      return navigation.filter(item => {
        // Hide Users and Roles for Company Owner
        if (item.href === '/users' || item.href === '/roles') {
          return false
        }
        return true
      }).map(item => {
        const companyId = user?.company?.id
        // For Company Owner, change companies href to their company preview
        if (item.href === '/companies' && companyId) {
          return { 
            ...item, 
            href: `/companies/${companyId}`,
            name: 'My Company' // Change the display name
          }
        }
        return item
      })
    }

    // Other roles - basic access (customize as needed)
    return navigation.filter(item => {
      // Hide sensitive areas for other roles
      if (['/users', '/roles', '/companies'].includes(item.href)) {
        return false
      }
      return true
    })
  }

  const filteredNavigation = getFilteredNavigation()

  return (
    <div className="flex h-screen bg-secondary-50">
      {/* Debug info */}
      <div className="fixed top-0 left-0 z-50 bg-red-500 text-white p-2 text-xs">
        Layout Rendered - User: {user ? 'Yes' : 'No'}
      </div>
      
      {/* Sidebar */}
      <Sidebar 
        navigation={filteredNavigation}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        currentPath={location.pathname}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden lg:ml-72">
        {/* Header */}
        <Header 
          setSidebarOpen={setSidebarOpen}
          user={user}
        />

        {/* Page content */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-secondary-50">
          <div className="container mx-auto px-6 py-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout
